import triggers from '../store/triggers'
import { state } from '../store/state'

const dqs = (selector) => document.querySelector(selector)
const priceSelector = '#ProductPrice-product-template .money'
const compareSelector = '#ComparePrice-product-template .money'
const discountSelector = '#ProductSaleTag-product-template span'

let mainPrice = dqs(priceSelector)
let comparePrice = dqs(compareSelector)
let discount = dqs(discountSelector)
let firstLoad = true

const updatePrice = (variant) => {
  if (firstLoad) {
    mainPrice = dqs(compareSelector)
    comparePrice = dqs(priceSelector)
    discount = dqs(discountSelector)

    firstLoad = false
  }

  if (!variant) return

  const { price: pNew } = variant
  // 15% for gift cards
  const priceCompare = pNew * 0.85 / 100
  // extra 15% for hot deals
  const price = pNew / 100

  if (mainPrice) {
    mainPrice.textContent = '$' + (price).toFixed(2)
  }

  if (comparePrice) {
    comparePrice.textContent = '$' + (priceCompare).toFixed(2)
    comparePrice.hidden = !priceCompare
  }

  if (discount) {
    discount.textContent = '-15% OFF'
  }
}

const price = () => {
  updatePrice(state.variant)
  triggers.on('state:variant', updatePrice)
}

export default price
